export const ReviewTypeLabels = {
  COMMUNICATION: "Communication",
  ONE: "One-on-One",
  QUARTER: "Quarterly Review",
  ANNUAL: "Annual Review"
};
